<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { setLocale, getAvailableLocales } from '../i18n'

const { locale } = useI18n()
const availableLocales = getAvailableLocales()

const currentLocale = computed({
  get: () => locale.value,
  set: (value) => {
    setLocale(value)
  }
})

const changeLanguage = (event) => {
  const newLocale = event.target.value
  setLocale(newLocale)
}
</script>

<template>
  <div class="language-switcher">
    <select 
      v-model="currentLocale" 
      @change="changeLanguage"
      class="rounded-md border border-white border-opacity-35 bg-white px-2 py-1 text-gray-900 outline-none [color-scheme:light] text-sm"
    >
      <option 
        v-for="locale in availableLocales" 
        :key="locale.code" 
        :value="locale.code"
      >
        {{ locale.flag }} &nbsp;{{ locale.name }}
      </option>
    </select>
  </div>
</template>
